export default "__VITE_ASSET__BwwlwX1G__"